import { __extends } from "tslib";
var PageSeoDataBuilder = /** @class */ (function () {
    function PageSeoDataBuilder() {
        this.pageSeo = {
            title: '',
            description: '',
            robots: {
                noArchive: false,
                noFollow: false,
                noIndex: false
            }
        };
    }
    PageSeoDataBuilder.prototype.withTitle = function (title) {
        this.pageSeo.title = title;
        return this;
    };
    PageSeoDataBuilder.prototype.withDescription = function (desciption) {
        this.pageSeo.description = desciption;
        return this;
    };
    PageSeoDataBuilder.prototype.withNoArchive = function (val) {
        this.pageSeo.robots.noArchive = val;
        return this;
    };
    PageSeoDataBuilder.prototype.withNoIndex = function (val) {
        this.pageSeo.robots.noIndex = val;
        return this;
    };
    PageSeoDataBuilder.prototype.withNoFollow = function (val) {
        this.pageSeo.robots.noFollow = val;
        return this;
    };
    PageSeoDataBuilder.prototype.build = function () {
        return this.pageSeo;
    };
    return PageSeoDataBuilder;
}());
export { PageSeoDataBuilder };
var PageSeoBuilder = /** @class */ (function (_super) {
    __extends(PageSeoBuilder, _super);
    function PageSeoBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PageSeoBuilder;
}(PageSeoDataBuilder));
export { PageSeoBuilder };
//# sourceMappingURL=page-seo-builder.js.map